import { ExpTypeActionTypes, ExpTypeActions } from './exp-type.actions';
import { IExpType } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IExpType | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: ExpTypeActions): State {
    switch (action.type) {

        case ExpTypeActionTypes.LoadExpTypeState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case ExpTypeActionTypes.LoadExpTypeStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case ExpTypeActionTypes.LoadExpTypeStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case ExpTypeActionTypes.ExpTypeScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;